// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
display: flex;
    margin: 0;
    padding: 0;
}

.body {
    
     padding-top: 10px;
}

.head {
  padding-left: 10px;
  font-family: sans-serif ;
  font-size: 25px;
  margin-top: 10px;
  margin-bottom:0;
  
}

.two-column-layout {
  display: grid;
  grid-template-columns: 70% 30%;
  gap: 1.5rem;
}

@media (max-width: 1024px) {
  .two-column-layout {
    grid-template-columns: 60% 40%;
  }
}

@media (max-width: 768px) {
  .company-dashboard {
    margin-top: 2rem;
  }
}

@media (max-width: 964px) {
  .company-dashboard {
    gap: 1rem;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/Company/company.css"],"names":[],"mappings":"AAAA;AACA,aAAa;IACT,SAAS;IACT,UAAU;AACd;;AAEA;;KAEK,iBAAiB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,sBAAsB;EACxB;AACF","sourcesContent":[".dashboard-container {\ndisplay: flex;\n    margin: 0;\n    padding: 0;\n}\n\n.body {\n    \n     padding-top: 10px;\n}\n\n.head {\n  padding-left: 10px;\n  font-family: sans-serif ;\n  font-size: 25px;\n  margin-top: 10px;\n  margin-bottom:0;\n  \n}\n\n.two-column-layout {\n  display: grid;\n  grid-template-columns: 70% 30%;\n  gap: 1.5rem;\n}\n\n@media (max-width: 1024px) {\n  .two-column-layout {\n    grid-template-columns: 60% 40%;\n  }\n}\n\n@media (max-width: 768px) {\n  .company-dashboard {\n    margin-top: 2rem;\n  }\n}\n\n@media (max-width: 964px) {\n  .company-dashboard {\n    gap: 1rem;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
